import Autolinker from 'autolinker'
import * as React from 'react'

interface IAutolinkerTextProps {
  text: string
  tag?: string
}

export default class AutolinkerText extends React.PureComponent<
  IAutolinkerTextProps
> {
  public render() {
    const { tag, text, ...rest } = this.props

    if (!text) {
      return null
    }

    const autolinker = new Autolinker({ mention: false })
    const newText = autolinker.link(text)

    const props = {
      dangerouslySetInnerHTML: { __html: newText },
      ...rest,
    }

    return React.createElement(tag || 'div', props)
  }
}
